import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from 'react';
/** Whitespace, the characters `"'`<>\`, and control and format characters (`\p{C}`). */
const UNSAFE_IN_URL = /[\s"'`<>\\\p{C}]/u;
/**
 * Only an https address becomes a link. The API sends no other (`richtext.is_https_url`),
 * and the page does not take that on trust: an address it renders is one a participant clicks.
 * The same rule as there: a host, no credentials (`https://pflaum.de@example.test` leads to
 * the second host), nothing that could hide in or reverse the address.
 */
export function isHttpsUrl(value) {
    if (typeof value !== 'string' || value === '' || UNSAFE_IN_URL.test(value)) {
        return false;
    }
    try {
        const url = new URL(value);
        return url.protocol === 'https:' && url.hostname !== '' && url.username === '' && url.password === '';
    }
    catch {
        return false;
    }
}
/**
 * One line of formatted text, cut where a link starts and ends.
 *
 * The parser hands a link out span by span: `[**Neu** im Shop](https://…)` is two spans with
 * one address. Rendering every span on its own would turn one link into two, each with its
 * own tab stop and its own "(externer Link)". A run is one `<a>`.
 */
export function textRuns(line) {
    const runs = [];
    for (const span of line) {
        const href = isHttpsUrl(span.href) ? span.href : null;
        const last = runs.at(-1);
        if (last !== undefined && last.href === href) {
            last.spans.push(span);
        }
        else {
            runs.push({ href, spans: [span] });
        }
    }
    return runs;
}
function marked(span) {
    if (span.bold && span.italic) {
        return (_jsx("strong", { children: _jsx("em", { children: span.text }) }));
    }
    if (span.bold) {
        return _jsx("strong", { children: span.text });
    }
    return span.italic ? _jsx("em", { children: span.text }) : span.text;
}
export function RichText({ blocks, sponsored, still = false }) {
    const rel = sponsored ? 'sponsored noopener' : 'noopener';
    const line = (spans) => textRuns(spans).map((run, index) => {
        const text = run.spans.map((span, at) => _jsx(Fragment, { children: marked(span) }, at));
        if (run.href === null) {
            return _jsx(Fragment, { children: text }, index);
        }
        return still ? (_jsx("span", { className: "countdown-rich-text__link", children: text }, index)) : (_jsxs("a", { href: run.href, rel: rel, target: "_blank", children: [text, _jsx("span", { className: "countdown-sr-only", children: " (externer Link)" })] }, index));
    });
    return (_jsx(_Fragment, { children: blocks.map((block, index) => block.kind === 'list' ? (_jsx("ul", { children: block.lines.map((spans, at) => (_jsx("li", { children: line(spans) }, at))) }, index)) : (_jsx("p", { children: block.lines.map((spans, at) => (_jsxs(Fragment, { children: [at > 0 ? _jsx("br", {}) : null, line(spans)] }, at))) }, index))) }));
}
//# sourceMappingURL=RichText.js.map